import { Card, Input, Space, Table } from "@arco-design/web-react";
import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { WoFulfillmentAPI } from "@/apis/manufacturing";
import { WOFulfillmentStatus, WOFulfillmentStatusDef } from "@/enums/manufacturing";
import { EnumLabel, EnumSelect } from "@/components/Enum";
import { Number } from "@/components/Numeric";

export const WoFulfillmentList = () => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [status, setStatus] = useState(WOFulfillmentStatus.Fulfilled);
    const [fulfillmentNo, setFulfillmentNo] = useState();

    const getList = useCallback(async () => {
        const values = await WoFulfillmentAPI.query(page, { status, fulfillmentNo });
        setData(values.records);
        setTotal(values.total);
    }, [page, status, fulfillmentNo]);

    useEffect(() => {
        getList();
    }, [getList]);

    return (
        <Card title="Fulfillment Order" extra={
            <Space>
                <Input allowClear placeholder="Fulfillment#" style={{ width: 180 }} value={fulfillmentNo} onChange={setFulfillmentNo} />
                <EnumSelect enumObj={WOFulfillmentStatusDef} allowAll style={{ width: 200 }}
                    placeholder="Status"
                    value={status}
                    onChange={(val) => {
                        setStatus(val);
                    }} />
            </Space>
        }>
            <Table rowKey="id" columns={[
                {
                    title: "Fulfillment No",
                    render: (col, record) => {
                        return <Link to={"/workspace/manufacturing/wo-fulfillment/" + record.id}>{record.fulfillmentNo}</Link>
                    }
                },
                { title: "Status", dataIndex: "status", render: (col, record) => <EnumLabel enumObj={WOFulfillmentStatusDef} value={record.status} /> },
                {
                    title: "WO#",
                    render: (col, record) => <Link to={"/workspace/manufacturing/work-order/" + record.workOrderId}>{record.workOrderNo}</Link>
                },
                { title: "BOM Name", dataIndex: "bomName" },
                { title: "Fulfilled Qty", dataIndex: "fulfilledQty", render: (val) => <Number value={val} /> },
                { title: "Fulfill Date", dataIndex: "fulfillDate" },
                { title: "Warehouse", dataIndex: "warehouseName" },
            ]} data={data} pagination={{ total, current: page, pageSize: 20 }} onChange={(pagination) => setPage(pagination.current)} />
        </Card>
    )
}
